import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { TbCirclePlus, TbCopy } from "react-icons/tb";
import "./CreateOrCopyChoiceModal.scss";

interface CreateOrCopyChoiceModalProps {
  show: boolean;
  onHide: () => void;
  onCreateNew: () => void;
  onCopyFrom: () => void;
}

const CreateOrCopyChoiceModal: React.FC<CreateOrCopyChoiceModalProps> = ({
  show,
  onHide,
  onCreateNew,
  onCopyFrom,
}) => {
  const { t } = useTranslation();

  const handleCreateNew = () => {
    onHide();
    onCreateNew();
  };

  const handleCopyFrom = () => {
    onHide();
    onCopyFrom();
  };

  return (
    <Modal show={show} onHide={onHide} centered className="create-or-copy-choice-modal">
      <Modal.Header closeButton className="create-or-copy-modal-header">
        <div className="create-or-copy-modal-header-inner">
          <Modal.Title className="create-or-copy-modal-title">{t("create_new_chatbot")}</Modal.Title>
          <p className="create-or-copy-modal-subtitle">{t("create_or_copy_subtitle")}</p>
        </div>
      </Modal.Header>
      <Modal.Body className="create-or-copy-modal-body">
        <div className="create-or-copy-options">
          <button
            type="button"
            className="create-or-copy-option create-or-copy-option-new"
            onClick={handleCreateNew}
          >
            <span className="create-or-copy-option-icon create-or-copy-option-icon-new">
              <TbCirclePlus size={28} />
            </span>
            <span className="create-or-copy-option-title">{t("create_new")}</span>
            <span className="create-or-copy-option-desc">{t("create_new_description")}</span>
          </button>
          <button
            type="button"
            className="create-or-copy-option create-or-copy-option-copy"
            onClick={handleCopyFrom}
          >
            <span className="create-or-copy-option-icon create-or-copy-option-icon-copy">
              <TbCopy size={28} />
            </span>
            <span className="create-or-copy-option-title">{t("copy_from")}</span>
            <span className="create-or-copy-option-desc">{t("copy_from_description")}</span>
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CreateOrCopyChoiceModal;
